import React from "react";
import { useAppContext } from "../../context";
import CurrencBody from "../CurrencBody";


export default function OnlineCourse() {

    const { currentRateData } = useAppContext();
    
    return (
        <>
            <CurrencBody data={currentRateData} />

        </>
    );
}
